import type { SVGProps } from 'react';
export const MoveCms = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <rect width={14} height={14} x={3} y={3} fill="#B284B9" rx={7} />
    <path
      fill="white"
      fillRule="evenodd"
      d="M9.67 5.62c.2-.16.46-.16.66 0l1.45 1.19c.19.15.27.42.2.66a.55.55 0 0 1-.53.4h-.9v4.26h.9c.24 0 .45.16.52.4s0 .51-.19.66l-1.45 1.2a.5.5 0 0 1-.66 0l-1.45-1.2a.6.6 0 0 1-.2-.66c.08-.24.3-.4.53-.4h.9V7.87h-.9a.55.55 0 0 1-.52-.4c-.08-.24 0-.51.19-.66z"
      clipRule="evenodd"
    />
  </svg>
);
